export enum CustomIconPath {
  AddAverages = 'AddAverages',
  AddPitch = 'AddPitch',
  ArrowAxis = 'ArrowAxis',
  Auto = 'Auto', // e.g. for auto-assigned video suggestions
  Baseball = 'Baseball',
  Beta = 'Beta',
  BetaBeaker = 'BetaBeaker',
  CalibrateDevice = 'CalibrateDevice',
  CheckCircledFilled = 'CheckCircledFilled',
  CollapseAll = 'CollapseAll',
  ColumnCompress = 'ColumnCompress',
  ColumnStretch = 'ColumnStretch',
  FilledCircle = 'FilledCircle',
  FolderClosed = 'FolderClosed',
  FolderOpen = 'FolderOpen',
  Flag = 'Flag',
  FlagFilled = 'FlagFilled',
  Helmet = 'Helmet',
  HMenuShow = 'HMenuShow',
  HMenuHide = 'HMenuHide',
  MobileCrossed = 'MobileCrossed',
  R2F = 'R2F',
  RepeatOne = 'RepeatOne',
  RowCompress = 'RowCompress',
  RowsAdd = 'RowsAdd',
  RowStretch = 'RowStretch',
  SmallFilledCircle = 'SmallFilledCircle',
  SortAsc = 'SortAsc',
  SortDesc = 'SortDesc',
  Spinner = 'Spinner',
  SuperAdmin = 'SuperAdmin',
  SwitchOff = 'SwitchOff',
  SwitchOn = 'SwitchOn',
  TeamAdmin = 'TeamAdmin',
  Void = 'Void',

  // machine states
  BusyMachine = 'BusyMachine',
  ConnectedMachine = 'ConnectedMachine',
  DisconnectedMachine = 'DisconnectedMachine',
  LowerMachine = 'LowerMachine',
  Machine = 'Machine',
  ResetMachine = 'ResetMachine',

  // machine settings
  UpdateHardware = 'UpdateHardware',
  RestartMachine = 'RestartMachine',
  NewInstall = 'NewInstall',
  LogFW = 'LogFW',
  LogService = 'LogService',

  // admin portal
  ShotHistory = 'ShotHistory',
}
